import React from 'react';
import SRListItem from './SRListItem';
import styles from '../../../styles/modules/components/tracker.module.scss';

interface SRListProps {
    data:any[],
    onClickTrack: (ref_no) => void,
}

interface SRListState {
    data:any[],
    selected_sr:string
}

class SRList  extends React.Component<SRListProps,SRListState> {
    constructor(props) {
        super(props);
        this.state = {
            data:props.data ? props.data : [],
            selected_sr:""
        }
    }

    trackSR = (ref_no:string) => {
        this.props.onClickTrack(ref_no);
    }

    componentDidUpdate (prevProps) {
        if (prevProps !== this.props) {
            this.setState({ data: this.props.data });
        }
    }

    render() {
        const { data } = this.state;
        return(
            <>
                <ul className={styles.sr_list}>
                    {
                        data.map((sr) => <SRListItem {...sr} isSelected={false}  key={sr.ref_no} action={this.trackSR} />)
                    }
                </ul>
            </>
        )
    }
}


export default SRList;